/**
 * Created by swandelow on 09/05/17.
 */
angular.module('CarsSaraBo').directive('fleetComponent', function () {
    return {
        restrict: 'E',
        controller: ['$routeParams', 'FleetService', '$http', '$location', 'LoadingWheelService', 'NotificationService', 'ModalService', 'SessionService', FleetController],
        controllerAs: 'ctrl',
        templateUrl: 'templates/fleet/fleet.component.html',
        scope: {} // isolated scope
    };
});

function FleetController($routeParams, fleetService, $http, $location, loadingWheelService, notificationService, modalService, sessionService) {
    var vm = this;

    vm.initialize = function () {
        loadingWheelService.show();
        loadCompany();
        loadData();
        vm.editableFleet = sessionService.loggedUserAllowed('PERM_FLEET_CREATE') || sessionService.loggedUserAllowed('PERM_FLEET_EDIT') || sessionService.loggedUserAllowed('PERM_FLEET_DELETE');
    };

    function loadCompany() {
        var fields = "name,category,passengers,largeBags,smallBags,doors,transmission,airConditioning,assistedDirection,"
            + "radioCDPlayer,centralLocking,electricWindows,airbags,absBrakes";
            fleetService.get({companyOid: $routeParams.oid}, function (response) {
            vm.fleet = response;
            loadingWheelService.hide();
        });
    }

    function loadData() {
        $http.get("../rest/data/brands/" + $routeParams.oid).success(function (response) {
            vm.brands = response;
        });

        vm.transmisions = ["M", "A"];
        vm.doors = [2, 3, 4, 5];
        vm.passengers = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
        vm.baggage = [0, 1, 2, 3, 4, 5, 6];
    }

    vm.create = function () {
        $location.path("/company/" + $routeParams.oid + "/fleet/new")
    };

    vm.edit = function (car) {
        if (vm.editableFleet) {
            if (this.cellIndex != 1) {
                $location.path("/company/" + $routeParams.oid + "/fleet/" + car.oid)
            }
        }
    };

    vm.itemsToRemove = function () {
        return _.filter(vm.fleet, {"selected": true});
    };

    vm.remove = function () {
        var toRemove = vm.itemsToRemove();

        if (toRemove.length == 0) return;

        modalService.show("REMOVE_CAR_TITLE", "REMOVE_CAR", function () {
            toRemove.forEach(function (e) {
                fleetService.remove({companyOid: $routeParams.oid, oid: e.oid})
                    .$promise
                    .then(function (response) {
                        vm.fleet.splice(vm.fleet.indexOf(e), 1);
                        notificationService.notifyInfoByCode('common.confirmationMessage.SUCCESS_DELETE');
                    });
            });
        });
    };

    vm.initialize();
}


//////////////////
// WEBPACK FOOTER
// ./public/app/fleet/fleet.component.js
// module id = 893
// module chunks = 3